import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { DecimalPipe } from '@angular/common';

export interface salesMasterHoldDetailsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface salesMasterHoldDetails { 
    phBillId?: any;
    phMedicineId:string;
    phBatch:string;
    phExpDate:any;
    phSellRate:number;
    phQty:number;
    phSellAmount:number;
    phDiscPercentage:number;
    phDiscAmt:number;
    phDiscountValue:string;
    phDiscountwithAmount:any;
    phGSTPercentage:number;
    phGSTAmount:string;
    phGSTWithAmount:string;
    phNetAmount:number;
    phCostRate:number;
    phCostAmount:number;
    // phMrpRate:any;
    // phMrpAmount:any;
    PhUnitMrpRate:number;
    PhStripMrpAmount:number;
    branch:string;
    tenant:string;
    tenantId: string;
    branchId: string;    
    
    parameters?: salesMasterHoldDetailsParameter[];
    links?: any;
}


export abstract class salesMasterHoldDetailsData {
    abstract create(url: string,data: salesMasterHoldDetails): Observable<any>;
}
